import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ token, css }: any) => ({
  productItemCard: css`
    text-align: center;
    border-color: transparent;
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;
  `,
  productItemCardBody: css`
    padding-inline: 8px !important;
    padding-block: 16px 32px !important;
  `,
  productItemCardCover: css`
    overflow: hidden;
    position: relative;
  `,
  productItemImage: css`
    margin: auto;
    width: 100%;
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
    object-fit: contain;
    aspect-ratio: 10 / 10;
    overflow: hidden;
  `,
  productItemLink: css`
    cursor: pointer;
  `,

  productItemContent: css``,
  productItemContentLink: css`
    width: 100%;
    min-height: 32px;
  `,
}));

export const useSharedProductCardStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
